import itemStyle from './funnel.data.emphasis.itemStyle'
import label from './funnel.data.emphasis.label'
import labelLine from './funnel.data.emphasis.labelLine'

export default {
  name: "emphasis",
  nickname: "高亮",
  desc: "emphasis",
  type: "object",
  props: {
    itemStyle,
    label,
    labelLine,
  },
}
